module.exports = __webpack_public_path__ + "static/img/youshi1.d3e86ada.png";